import { ContentBlocks } from "../../blocks"
import { Img } from "../../../layout/Img"
import { ProfileLink } from "../../blocks/ContentBlocks/ProfileList/ProfileLink"

export const Profiles = ({ entry }) => {
  // console.log(entry)
  return (
    <>
      <div className="relative z-10 masked-image ">
        <div className="w-full h-96 bg-primary" />
      </div>

      <div className="container relative z-20 mx-auto -mt-80 md:w-full lg:w-8/12">
        <div className="mx-8 md:mx-auto">
          <h2 className="text-base text-white uppercase">Our Team</h2>
          <h3 className="mt-3 text-3xl font-semibold leading-9 text-white sm:text-4xl md:text-5xl xl:text-7xl">
            {entry.title}
          </h3>
          <h4 className="mb-6 text-white">
            {entry.profileRole} | {entry.profileCategory[0].title}
          </h4>
          <div className="max-w-xs overflow-hidden rounded-full">
            <Img 
            image={entry?.profilePicture[0]} 
            imgStyle={{ borderRadius: '100%' }}
            />
          </div>
          <div className="mt-6 mb-12 redactor lg:w-9/12">
            <div className="flex">
              {entry.profileLinks.map(({ uid, ...rest }) => (
                <div key={uid} className="text-center">
                  <ProfileLink
                    {...rest}
                    customClass="text-secondary mt-3 text-sm"
                  />
                </div>
              ))}
            </div>
            {entry?.profileBio?.length > 0 && (
              <h5 className="mt-8">Profile</h5>
            )}
            <div
              dangerouslySetInnerHTML={{
                __html: entry.profileBio || " ",
              }}
            />
          </div>
        </div>
      </div>

      {entry?.contentBlocks?.length > 0 && (
        <ContentBlocks blocks={entry.contentBlocks} />
      )}

      {/* Footer */}
      {entry?.footerCTA?.length > 0 && (
        <FooterCTA
          ctaHeading={entry.footerCTA[0].ctaHeading}
          ctaLink={entry.footerCTA[0].ctaLink}
        />
      )}
    </>
  )
}